var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"copy-right"}},[_c('v-divider'),_c('v-card-text',[_vm._v(" © "+_vm._s(_vm.year)+" Briller All Rights Reserved.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }